module.exports = __webpack_public_path__ + "images/FUSA_icons/050-shopping-bag-2.eb53df31896b6beb72f5041e5e3bf162.svg";